module.exports = __webpack_public_path__ + "static/Ville-Kaituri-9dc1f7ed2ef946b1d0812292b9fec912.jpeg";